import React from "react";
import { useTranslation } from "react-i18next";

export const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-[#F4EFE6] border-t border-[#EAE3D9] mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div>
          <div className="font-serif text-3xl text-[#2C2A29]">
            Stay<span className="text-[#C86D53]">TLV</span>
          </div>
          <p className="text-sm text-[#8C7A6B] mt-2">{t("footer.tagline")}</p>
        </div>
        <div className="text-xs text-[#8C7A6B]">
          © {new Date().getFullYear()} StayTLV. {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
};
